import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SVGComponent = props => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 20}
        height={props.height ?? 20}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <Path
            d="M5 10.698L8.58699 14.6167L14.9669 5.38757"
            stroke={props.color ?? ds.colorValue.icon.primary}
            strokeWidth={1.75}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
);
export default SVGComponent;
